<template>
  <div class="message">
    <date-formatter class="caption" :value="value.sentAt"></date-formatter>
    <p class="body-1" v-html="message"></p>
    <component v-if="preview" :is="preview" :value="this.value.data"></component>
  </div>
</template>

<script>
  import { Date as DateFormatter } from '@/components/formatters'
  import OfferPreview from './previews/Offer.vue'
  export default {
    components: {
      DateFormatter
    },
    props: {
      value: {
        type: Object,
        requires: true
      }
    },
    computed: {
      message () {
        return this.value.content.replace(/\n/g, '<br/>')
      },
      preview () {
        if (!this.value.data) { return null }
        return {
          offer: OfferPreview,
          page: OfferPreview
        }[this.value.data.type]
      }
    }
  }
</script>

<style scoped>
  .message {
    position: relative;
  }

  .message time {
    position: absolute;
    top: 0;
    right: 0;
    opacity: 0;
    color: #ccc;
    padding: .5em;
    margin-right: -.5em;
    background: white;
    transition: opacity 300ms;
  }

  .message:hover time {
    opacity: .95;
  }
</style>



// WEBPACK FOOTER //
// src/components/messenger/Message.vue